import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipstationDefaultText: {
    description: 'Text displayed to the user to describe the default strategy when it was auto-generated',
    defaultMessage: 'ShipStation',
    id: 'W/wyWM',
  },
});
